"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LowerLatinLetterNumberConverter = exports.UpperLatinLetterNumberConverter = void 0;
var tslib_1 = require("tslib");
var list_level_properties_1 = require("../numbering-lists/list-level-properties");
var alphabet_based_number_converter_1 = require("./alphabet-based-number-converter");
var UpperLatinLetterNumberConverter = (function (_super) {
    tslib_1.__extends(UpperLatinLetterNumberConverter, _super);
    function UpperLatinLetterNumberConverter() {
        var _this = _super.call(this, ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']) || this;
        _this.type = list_level_properties_1.NumberingFormat.UpperLetter;
        return _this;
    }
    return UpperLatinLetterNumberConverter;
}(alphabet_based_number_converter_1.AlphabetBasedNumberConverter));
exports.UpperLatinLetterNumberConverter = UpperLatinLetterNumberConverter;
var LowerLatinLetterNumberConverter = (function (_super) {
    tslib_1.__extends(LowerLatinLetterNumberConverter, _super);
    function LowerLatinLetterNumberConverter() {
        var _this = _super.call(this, ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']) || this;
        _this.type = list_level_properties_1.NumberingFormat.LowerLetter;
        return _this;
    }
    return LowerLatinLetterNumberConverter;
}(alphabet_based_number_converter_1.AlphabetBasedNumberConverter));
exports.LowerLatinLetterNumberConverter = LowerLatinLetterNumberConverter;
